import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Logo from "../assets/images/Logo.png";

const Footer = () => (
  <Box mt="80px" bgcolor="#fff3f4">
    <Stack gap="40px" alignItems="center" px="40px" pt="24px" pb="40px">
      <img src={Logo} alt="logo" style={{ width: "52px", height: "52px" }} />
      <Typography
        variant="h6"
        pb="40px"
        mt="20px"
        textAlign="center"
        fontFamily="Alegreya"
      >
        Made with ❤️ for fitness lovers
      </Typography>
    </Stack>
  </Box>
);

export default Footer;
